import { AxiosResponse } from 'axios';
import { leagueDelete, leagueList, leagueUpdate } from '@/api/league';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { ILeagueApiListResponse, ILeagueDeleteResponse, ILeagueFilters, ILeagueUpdateResponse } from '@/types/league';

export const leagueService = {
    async list(params: IListParams<ILeagueFilters>): Promise<AxiosResponse<ILeagueApiListResponse>> {
        try {
            return await baseListService<ILeagueApiListResponse>(leagueList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('League API Error:', e);
            throw new AppError('Unable to load league list, request error', { cause: e });
        }
    },

    async delete(id: number): Promise<AxiosResponse<ILeagueDeleteResponse>> {
        try {
            return await leagueDelete({ rows: [{ id }] });
        } catch (e) {
            console.error('League delete API Error:', e);
            throw new AppError('Unable to delete league, request error', { cause: e });
        }
    },

    async updateAssociation(id: number, customLeagueId: number | null): Promise<AxiosResponse<ILeagueUpdateResponse>> {
        try {
            return await leagueUpdate({ rows: [{ id, custom_league_id: customLeagueId }] });
        } catch (e) {
            console.error('League update API Error:', e);
            throw new AppError('Unable to update league association, request error', { cause: e });
        }
    },
};
